import { type FormControlProps } from '@mui/base'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

import { FormControl, FormLabel, Option, Select } from 'base-ui'

import { useQuantitySelectionControls } from '../../../product-page/components/product-page-context/useQuantitySelectionControls'

import { ExperimentOwnBrandsOverlayAddToCartCta } from './ExperimentOwnBrandsOverlayAddToCartCta'
import {
  useExperimentOwnBrandsOverlayBuildAddToCartParams,
  useExperimentOwnBrandsOverlaySelectionOptions,
} from './ExperimentOwnBrandsOverlayAddToCartHelpers'

export const ExperimentOwnBrandsOverlayAddToCartGroup: FC<
  FormControlProps & {
    product: PimProductWithVariantsV1
  }
> = (props) => {
  const { product } = props
  const { offers } = product
  const selectOptions = useExperimentOwnBrandsOverlaySelectionOptions(
    product,
    offers?.[0],
  )
  const quantitySelectionControls = useQuantitySelectionControls({
    currentVariant: product,
  })

  return (
    <div className="flex w-full flex-row justify-between pt-2">
      <FormControl
        {...props}
        className="w-[108px]"
        value={quantitySelectionControls.quantity}
      >
        <FormLabel htmlFor="quantity" id="quantity-label">
          <FormattedMessage id="general.label.quantity" />
        </FormLabel>
        <Select
          aria-labelledby="quantity-label"
          data-qa-id="product-quantity-select"
          id="quantity"
          onChange={(event, value): void => {
            if (!value) {
              return
            }
            quantitySelectionControls.setQuantity(value)
          }}
          value={quantitySelectionControls.quantity}
        >
          {selectOptions.map((option) => (
            <Option
              data-qa-id="product-quantity-select-option"
              data-value={option.value}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </Option>
          ))}
        </Select>
      </FormControl>
      <ExperimentOwnBrandsOverlayAddToCartCta
        addToCartParams={useExperimentOwnBrandsOverlayBuildAddToCartParams(
          quantitySelectionControls.quantity,
          product,
        )}
      />
    </div>
  )
}
